const DB_NAME = 'codeframe-projects';
const STORE = 'docs';
const VERSION = 1;

export interface ProjectRecord {
  projectId: string;
  doc: string;          // serialized CanvasDoc JSON
  baseVersion: number;  // server docVersion this local copy derives from
  dirty: boolean;       // unsaved local edits
  updatedAt: number;
}

let dbPromise: Promise<IDBDatabase> | null = null;
function openDb(): Promise<IDBDatabase> {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: 'projectId' });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return openDb().then((db) => new Promise<T>((resolve, reject) => {
    const req = fn(db.transaction(STORE, mode).objectStore(STORE));
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  }));
}

export const projectStore = {
  async save(rec: ProjectRecord): Promise<void> { await tx('readwrite', (s) => s.put(rec)); },
  async load(projectId: string): Promise<ProjectRecord | null> {
    const rec = await tx<ProjectRecord | undefined>('readonly', (s) => s.get(projectId));
    return rec ?? null;
  },
  async remove(projectId: string): Promise<void> { await tx('readwrite', (s) => s.delete(projectId)); },
};
